import { render, staticRenderFns } from "./EmptyParallelTextPartNode.vue?vue&type=template&id=42bbc37c&scoped=true&"
import script from "./EmptyParallelTextPartNode.vue?vue&type=script&lang=js&"
export * from "./EmptyParallelTextPartNode.vue?vue&type=script&lang=js&"
import style0 from "./EmptyParallelTextPartNode.vue?vue&type=style&index=0&id=42bbc37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bbc37c",
  null
  
)

component.options.__file = "EmptyParallelTextPartNode.vue"
export default component.exports